import { useCallback, useState } from 'react'
import { produce } from 'immer'

export function useLocationCardsState() {
  const [openStates, setOpenStates] = useState(() => new Set<number>())

  const toggleOpenState = useCallback(
    (id: number) =>
      setOpenStates((state) =>
        produce(state, (draft) => {
          if (draft.has(id)) draft.delete(id)
          else draft.add(id)
        }),
      ),
    [],
  )

  return {
    openStates,
    toggleOpenState,
  }
}
